import { render, staticRenderFns } from "./FormFormaPago.vue?vue&type=template&id=2899d3a2&"
import script from "./FormFormaPago.vue?vue&type=script&lang=js&"
export * from "./FormFormaPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports